import React from 'react';
import SubnavMobileStyled from '../../../_atoms/SubnavMobileStyled';
import SubnavItem from '@molecules/SubnavItem';
import useViewer from "@hooks/useViewer";
import SubnavItemExternal from "@molecules/SubnavItemExternal";

const AccountMobileSubnav = () => {
    const viewer = useViewer();
    const isOfficial = viewer && viewer.official;

    return (
        <SubnavMobileStyled>
            <SubnavItem label="Account Preferences" to="/my-icsc/account/preferences" />
            <SubnavItem label="Edit Profile > Basic Information" to="/my-icsc/account/edit-profile/basic" />
            <SubnavItem label="Edit Profile > Contact Information" to="/my-icsc/account/edit-profile/contact" />
            <SubnavItem label="Edit Profile > Education & Employment" to="/my-icsc/account/edit-profile/education" />
            {isOfficial && <SubnavItem label="Edit Company Profile" to="/my-icsc/account/edit-company" />}
            <SubnavItem label="Update Password" to="/my-icsc/account/update-password" />
            <SubnavItem label="Billing & Payments > Payment History" to="/my-icsc/account/edit-billing/payment-history" />
            <SubnavItem label="Billing & Payments > Payment Preferences" to="/my-icsc/account/edit-billing/payment-preferences" />
            <SubnavItem label="Billing & Payments > Auto-Renew Membership" to="/my-icsc/account/edit-billing/auto-renew" />
        </SubnavMobileStyled>
    );
};

export default AccountMobileSubnav;
